export default {
  data() {
    return {
      props: {
        'content': 'Texto exemplo',
        'width': '300px',
        'fontSizeMobile': '12px',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        'zIndex': 'auto',
        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        }
      },
      internal_config: {
        content: 'Texto exemplo',
        fontSizeMobile: '12px',
        width: '300px',
        left: '0px',
        top: '0px',
        showDesktop: true,
        showMobile: true,
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
      },
      editing: false,
    }
  }
}
